import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import DynamicBreadcrumbs from '../Uitiles/DynamicBreadcrumbs';

const NotFound = () => {
  return (
    <div>
      <DynamicBreadcrumbs is404={true} />
      <main id="dc-main" className="">
        <div className="dc-haslayout dc-parent-section" style={{ marginTop: '150px', marginBottom: '150px' }}>
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-6">
                <div className="dc-errorpage">
                  <figure>
                    <img
                      src="//css.meddylist.com//wp-content/themes/doctreat/images/404.jpg"
                      alt="404 image"
                    />
                  </figure>
                </div>
              </div>
              <div className="col-sm-12 col-md-6">
                <div className="dc-errorcontent">
                  <div className="dc-title">
                    <h4>Something Went Wrong</h4>
                    <h3>Ooopps! Page Not Found</h3>
                  </div>
                  <div className="dc-description">
                    <p>If you didn't find what you were looking for, try a new search!</p>
                  </div>
                  <form className="dc-formtheme dc-formsearch" method="get" role="search" action="//css.meddylist.com//">
                    <fieldset>
                      <div className="form-group">
                        <input
                          type="search"
                          name="s"
                          defaultValue=""
                          className="form-control"
                          placeholder="Searching might help"
                        />
                        <div className="dc-btnarea">
                          <button type="submit" className="dc-btn">Search</button>
                          <span>
                            You can go back to&nbsp;
                            <Link to="/">Home</Link>
                            &nbsp;and start again
                          </span>
                        </div>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NotFound; 
